import {LinkTarget} from "./link-target";

/** A Linkview tile linking to an external URL — the original (and only) link
 *  kind before Anke's 2026-09-04 request to also link to Whiteboard documents. */
export class ExternalLinkTarget extends LinkTarget {

    public readonly kind = 'external' as const;

    public constructor(public readonly url: string) {
        super();
    }

    public toJSON(): Record<string, unknown> {
        return {kind: this.kind, url: this.url};
    }

}
